/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateGroup } from './RateGroup';
import {
    RateGroupFromJSON,
    RateGroupFromJSONTyped,
    RateGroupToJSON,
    RateGroupToJSONTyped,
} from './RateGroup';

/**
 * Summary of a room
 * @export
 * @interface RoomSummary
 */
export interface RoomSummary {
    /**
     * 
     * @type {string}
     * @memberof RoomSummary
     */
    roomId?: string;
    /**
     * The type of room. If there is an available direct booking rate, this is the direct booking room type. Otherwise, it will come from expedia.
     * @type {string}
     * @memberof RoomSummary
     */
    roomType?: string;
    /**
     * A description of a room. May contain html tags
     * @type {string}
     * @memberof RoomSummary
     */
    roomDescription?: string;
    /**
     * A code that uniquely defines a room for rooms at chains
     * @type {string}
     * @memberof RoomSummary
     */
    roomCode?: string;
    /**
     * Views from the room
     * @type {Array<string>}
     * @memberof RoomSummary
     */
    roomViews?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RoomSummary
     */
    maxAdultsAllowed?: number;
    /**
     * Types of beds in the room
     * @type {Array<string>}
     * @memberof RoomSummary
     */
    bedDescriptions?: Array<string>;
    /**
     * Size of the room in sq ft
     * @type {number}
     * @memberof RoomSummary
     */
    areaSqFt?: number;
    /**
     * Array of links to room images
     * @type {Array<string>}
     * @memberof RoomSummary
     */
    images?: Array<string>;
    /**
     * Array of room highlights/amenities
     * @type {Array<string>}
     * @memberof RoomSummary
     */
    highlights?: Array<string>;
    /**
     * 
     * @type {Array<RateGroup>}
     * @memberof RoomSummary
     */
    rates?: Array<RateGroup>;
}

/**
 * Check if a given object implements the RoomSummary interface.
 */
export function instanceOfRoomSummary(value: object): value is RoomSummary {
    return true;
}

export function RoomSummaryFromJSON(json: any): RoomSummary {
    return RoomSummaryFromJSONTyped(json, false);
}

export function RoomSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['room_id'] == null ? undefined : json['room_id'],
        'roomType': json['room_type'] == null ? undefined : json['room_type'],
        'roomDescription': json['room_description'] == null ? undefined : json['room_description'],
        'roomCode': json['room_code'] == null ? undefined : json['room_code'],
        'roomViews': json['room_views'] == null ? undefined : json['room_views'],
        'maxAdultsAllowed': json['max_adults_allowed'] == null ? undefined : json['max_adults_allowed'],
        'bedDescriptions': json['bed_descriptions'] == null ? undefined : json['bed_descriptions'],
        'areaSqFt': json['area_sq_ft'] == null ? undefined : json['area_sq_ft'],
        'images': json['images'] == null ? undefined : json['images'],
        'highlights': json['highlights'] == null ? undefined : json['highlights'],
        'rates': json['rates'] == null ? undefined : ((json['rates'] as Array<any>).map(RateGroupFromJSON)),
    };
}

export function RoomSummaryToJSON(json: any): RoomSummary {
    return RoomSummaryToJSONTyped(json, false);
}

export function RoomSummaryToJSONTyped(value?: RoomSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'room_id': value['roomId'],
        'room_type': value['roomType'],
        'room_description': value['roomDescription'],
        'room_code': value['roomCode'],
        'room_views': value['roomViews'],
        'max_adults_allowed': value['maxAdultsAllowed'],
        'bed_descriptions': value['bedDescriptions'],
        'area_sq_ft': value['areaSqFt'],
        'images': value['images'],
        'highlights': value['highlights'],
        'rates': value['rates'] == null ? undefined : ((value['rates'] as Array<any>).map(RateGroupToJSON)),
    };
}

